import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const NotificationTable = ({
  data = [],
  meta,
  language,
  onEdit,
  onDelete,
  onView,
  onSendNow,
  onPageChange,
}) => {
  const [sortDirection, setSortDirection] = useState("desc");

  const labels = {
    title: { en: "Title", ar: "العنوان" },
    body: { en: "Message", ar: "الرسالة" },
    audience: { en: "Audience", ar: "المستلمون" },
    date: { en: "Date", ar: "التاريخ" },
    status: { en: "Status", ar: "الحالة" },
    actions: { en: "Actions", ar: "الإجراءات" },
    read: { en: "Read", ar: "مقروء" },
    unread: { en: "Unread", ar: "غير مقروء" },
    allUsers: { en: "All Users", ar: "جميع المستخدمين" },
    specificUsers: { en: "Specific Users", ar: "مستخدمون محددون" },
    previous: { en: "Previous", ar: "السابق" },
    next: { en: "Next", ar: "التالي" },
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortDirection === "asc") {
      return new Date(a.date) - new Date(b.date);
    }
    return new Date(b.date) - new Date(a.date);
  });

  return (
    <div className="overflow-hidden">
      <div className="overflow-x-auto scrollbar-custom">
        <table className="w-full min-w-[800px]">
          <thead className="bg-muted border-b border-border">
            <tr>
              <th className="px-6 py-4 text-center text-sm font-semibold">
                {labels.title[language]}
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold">
                {labels.body[language]}
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold">
                {labels.audience[language]}
              </th>
              <th
               
               className="px-6 py-4 text-center text-sm font-semibold"
              >
                {labels.date[language]}
           
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold">
                {labels.status[language]}
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold">
                {labels.actions[language]}
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-border">
            {sortedData?.map((item) => (
              <tr
                key={item.id}
                className="hover:bg-muted/50 transition-smooth text-center"
              >
                <td className="px-6 py-4 font-medium">
                  {item.title}
                </td>

                <td className="px-6 py-4 text-text-secondary text-center">
                  {item.body}
                </td>

                <td className="px-6 py-4 text-center">
                  <span className="px-3 py-1 rounded-full text-xs bg-primary/10 text-primary">
                    {item.is_all
                      ? labels.allUsers[language]
                      : labels.specificUsers[language]}
                  </span>
                </td>

                <td className="px-6 py-4 text-text-secondary text-sm">
                  {item.date_text}
                </td>

                <td className="px-6 py-4 text-center">
                  <span
                    className={`px-3 py-1 rounded-full text-xs ${
                      item.is_read
                        ? "bg-success/10 text-success"
                        : "bg-warning/10 text-warning"
                    }`}
                  >
                    {item.is_read
                      ? labels.read[language]
                      : labels.unread[language]}
                  </span>
                </td>

                <td className="px-6 py-4">
                  <div className="flex justify-center gap-2">
                 

                  
                 

                    <button
                      onClick={() => onDelete(item)}
                      className="p-2 rounded-lg hover:bg-error/10 text-error"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination from backend meta */}
      {meta && (
        <div className="px-6 py-4 border-t border-border flex justify-between items-center">
          <Button
            variant="outline"
            size="sm"
            onClick={() =>
              onPageChange(meta.current_page - 1)
            }
            disabled={meta.current_page === 1}
            iconName="ChevronLeft"
          >
            {labels.previous[language]}
          </Button>

          <span className="text-sm text-text-secondary">
            {meta.current_page} / {meta.last_page}
          </span>

          <Button
            variant="outline"
            size="sm"
            onClick={() =>
              onPageChange(meta.current_page + 1)
            }
            disabled={meta.current_page === meta.last_page}
            iconName="ChevronRight"
            iconPosition="right"
          >
            {labels.next[language]}
          </Button>
        </div>
      )}
    </div>
  );
};

export default NotificationTable;